import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { ITimesheet } from "../../models/Timesheet";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { baseUrl, Fetch } from "../../shared/Fetch";

interface IProps {
    singleData: ITimesheet,
    open: boolean,
    hideDialog: () => void,
    reloadDialog: () => void,
    toast: any,
    setReload: (is: boolean) => void,
    po?: IPurchaseOrder,
    recent: ITimesheet,
    timeSheetCount: number,
}

export const AutoFillTimeSheet = (props: IProps) => {
    const [timeSheetData, setTimeSheetData] = useState<ITimesheet | null>(null);
    const [recentData, setRecentData] = useState<ITimesheet | null>(null);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [timesheetFile, setTimesheetFile] = useState<File | null | any>(null);
    const [timeSheetDateLeft, setTimeSheetDateLeft] = useState<string[] | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [editRowIndex, setEditRowIndex] = useState<number | null>(null);
    const dt = useRef<any>(null);

    const from_Date = (rowData: ITimesheet, rowIndex: number) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";

        return (
            (editRowIndex != null && editRowIndex === rowIndex) ?
                <div className={'field col-12 md:col-12'}>
                    <Calendar view={"date"} value={rowData.fromDate} onChange={(e) => {
                        tableData.tableData[rowIndex].toDate = e.target.value;
                        setTableData({ tableData: tableData.tableData, loading: false });
                    }} disabled={false} placeholder={""} showButtonBar dateFormat={"dd-mm-yy"} showIcon />
                </div>
                :
                <>{date}</>
        );
    }
    const to_Date = (rowData: ITimesheet, rowIndex: number) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return ((editRowIndex != null && editRowIndex === rowIndex) ?
            <div className={'field col-12 md:col-12'}>
                <Calendar view={"date"} value={rowData.toDate} onChange={(e) => {
                    tableData.tableData[rowIndex].toDate = e.target.value;
                    setTableData({ tableData: tableData.tableData, loading: false });
                }} disabled={false} placeholder={""} showButtonBar dateFormat={"dd-mm-yy"} showIcon />
            </div>
            :
            <>{date}</>
        );
    }
    const work_Hours = (rowData: ITimesheet, rowIndex: number) => {
        return (
            (editRowIndex != null && editRowIndex === rowIndex) ?
                <div className={'field col-12 md:col-12'}>
                    <InputText disabled={false} value={rowData.workHours} placeholder={""} type={"number"} onChange={(e) => {
                        tableData.tableData[rowIndex].workHours = e.target.value;
                        setTableData({ tableData: tableData.tableData, loading: false });
                    }} />
                </div>
                :
                <p>{rowData.workHours}</p>
        );
    }
    const time_Sheet = (rowData: ITimesheet, rowIndex: number) => {
        return (
            (editRowIndex != null && editRowIndex === rowIndex) ?
                <FileUpload chooseLabel="Choose File" mode="basic" name="file" accept="*" maxFileSize={10000000} customUpload auto uploadHandler={fileUploade} />
                :
                <p></p>

        )
    }
    const comment = (rowData: ITimesheet, rowIndex: number) => {
        return (
            (editRowIndex != null && editRowIndex === rowIndex) ?
                <div className={'field col-12 md:col-12'}>
                    <InputText maxLength={500} value={rowData.comments} disabled={false} placeholder={""} type={"text"} onChange={(e) => {
                        tableData.tableData[rowIndex].comments = e.target.value;
                        setTableData({ tableData: tableData.tableData, loading: false });
                    }} />
                </div>
                :
                <p>{rowData.comments}</p>
        );
    }


    const actionBodyTemplate = (rowData: ITimesheet, rowIndex: number) => {
        return (
            (editRowIndex != null && editRowIndex === rowIndex) ?
                <div className={'field col-12 md:col-12'}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="button" loading={loading} onClick={() => onSubmit(tableData.tableData[editRowIndex])}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="Cancel" type="button" loading={loading} onClick={() => onClear()}></Button>
                </div>
                :
                <Button icon="pi pi-pencil" label="Edit" className="p-button-rounded p-button-text w-5rem" onClick={() => {
                    setTimesheetFile(null);
                    setEditRowIndex(prev => prev = rowIndex);
                }} />
        );
    };

    const fileUploade = (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 1024000) {
            props.toast.current.show({ severity: 'error', content: "Document should be less than 1 MB." });
            event.options.clear();
        } else {
            setTimesheetFile(event.files[0]);
            event.options.clear();
        }
    }

    const uploadeFile = async () => {
        // setLoading(true);
        let formData = new FormData();
        formData.append("file", timesheetFile);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Ticket/file`, params);
        if (response) {
            const data = await response.text();
            // setValue("timeSheet_Path", data);
            props.toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
        }
        // setLoading(false);
    }

    const onHide = () => {
        setTimeSheetData(null);
        setRecentData(null);
        setTableData({ tableData: [], loading: false });
        setTimesheetFile(null);
        setLoading(false);
        setEditRowIndex(null);
        props.hideDialog();
    };

    const onClear = () => {
        setTimeSheetData(null);
        setRecentData(null);
        setTableData({ tableData: tableData.tableData, loading: false });
        setTimesheetFile(null);
        setLoading(false);
        setEditRowIndex(null);
    };

    const onSubmit = (data: ITimesheet) => {
        // } else if (data.workHours === null || data.workHours?.toString().trim() === "") {
        //     props.toast.current.show({ severity: 'error', detail: "Please enter working hours", life: 3000 });
        // } else if (data.comments === null || data.comments?.toString().trim() === "") {
        //     props.toast.current.show({ severity: 'error', detail: "Please enter comments", life: 3000 });
        // } else if(timesheetFile !== null) {
        //     props.toast.current.show({ severity: 'error', detail: "Please select a file to upload", life: 3000 });
        // }
        if (data.fromDate === null) {
            props.toast.current.show({ severity: 'error', detail: "Please select a from date", life: 3000 });
        } else if (data.toDate === null) {
            props.toast.current.show({ severity: 'error', detail: "Please select a to date", life: 3000 });
        } else {
            if (editRowIndex !== null && editRowIndex > 0) {
                props.toast.current.show({ severity: 'error', detail: "Previous Time Sheet not uploaded, upload them first", life: 3000 });
            } else {
                // console.log(data);
                // console.log(timesheetFile);
                saveToDB(data);
            };
        }
    };
    const saveToDB = async (data: ITimesheet) => {
        setLoading(true);
        const method = "POST";
        const message = "Added Successfully";

        delete data.timesheet_ID;

        const formData = new FormData();
        formData.append('file', timesheetFile);
        formData.append('newtimesheet', JSON.stringify(data));
        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            //query:`typeoffile=${imageType}`,
            body: formData
        };
        const response = await fetch(`${baseUrl}Timesheet/multi`, params);

        // const response = await Fetch("Timesheet", method, data, null, props.toast);
        if (response) {
            tableData.tableData.splice(editRowIndex || 0, 1);
            setTableData(prev => prev = { tableData: tableData.tableData, loading: false });
            setTimesheetFile(null);
            setEditRowIndex(null);
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadDialog();
            // onClear();
        }
        setLoading(false);
    };

    const getLefTimeSheetsData = async (poID: number) => {
        const response = await Fetch("ResourceTimesheet/getLeftTimeSheetDates", "GET", null, `PO_ID=${poID}&byInternal=1`, null);
        if (response) {
            const data = await response.json();
            setTimeSheetDateLeft(data);
        }
    }

    useEffect(() => {
        if (props.open) {
            if (props?.po?.pO_ID) {
                getLefTimeSheetsData(props?.po?.pO_ID);
            }
            // setRecentData(prev => prev = props.recent);
            // setTimeSheetData({
            //     ...props.singleData,
            //     pO_ID: props.po?.pO_ID,
            //     consultant_ID: props.po?.consultant_ID,
            // });
        };
    }, [props.open, recentData]);

    useEffect(() => {
        // if (timeSheetData !== null) {
        // console.log("A");
        // console.log("props.timeSheetCount : " + props.timeSheetCount + " , tableData.tableData.length : " + tableData.tableData.length)
        // console.log("props.timeSheetCount > tableData.tableData.length", props.timeSheetCount > tableData.tableData.length);
        // if (props.timeSheetCount > tableData.tableData.length) {
        //     // console.log("B");
        //     setTableData({ tableData: tableData.tableData, loading: true });
        //     // console.log(`fromDate : ${timeSheetData.fromDate} , toDate : ${timeSheetData.toDate} , data : `, timeSheetData);
        //     if (recentData?.toDate === null || recentData === undefined) {
        //         // console.log("C");
        //         timeSheetData.fromDate = new Date(props?.po?.project_Start_Date || "");
        //         const currentDate = new Date(props?.po?.project_Start_Date || "");
        //         let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay()));
        //         const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
        //         timeSheetData.toDate = toDate;
        //         setTableData(prev => prev = { tableData: [...tableData.tableData, timeSheetData], loading: false });
        //         setRecentData(prev => prev = timeSheetData);
        //     } else if (recentData?.toDate && recentData?.toDate !== null) {
        //         // console.log("D");
        //         const fromDate = new Date(new Date(recentData.toDate || "").setDate(new Date(recentData.toDate || "").getDate() + 1));
        //         timeSheetData.fromDate = fromDate;
        //         const toDate = new Date(new Date(recentData.toDate || "").setDate(new Date(recentData.toDate || "").getDate() + 7));
        //         timeSheetData.toDate = toDate;
        //         // console.log(`fromDate : ${recentData.fromDate} , toDate : ${recentData.toDate} , data : `, timeSheetData);
        //         setTableData(prev => prev = { tableData: [...tableData.tableData, timeSheetData], loading: false });
        //         setRecentData(prev => prev = timeSheetData);
        //     };
        // };
        if (timeSheetDateLeft != null && timeSheetDateLeft.length > 0) {
            setTableData(prev => prev = { tableData: tableData.tableData, loading: true });
            let data: any[] = timeSheetDateLeft.map((e) => {
                let newData: any = { pO_ID: props?.po?.pO_ID };
                const fromDate = new Date(e || "");
                newData.fromDate = fromDate;
                const toDate = new Date(new Date(e || "").setDate(new Date(e || "").getDate() + 6));
                newData.toDate = toDate;
                return newData;
            });
            setTableData(prev => prev = { tableData: data, loading: false });
            // setRecentData(prev => prev = timeSheetData);
        }
        // }
    }, [timeSheetDateLeft]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Consultant TimeSheet" modal className="p-fluid" onHide={onHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                    ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                    loading={tableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="fromDate" header="From Date" body={(rowData, options) => from_Date(rowData, options.rowIndex)} />
                    <Column field="toDate" header="To Date" body={(rowData, options) => to_Date(rowData, options.rowIndex)} />
                    <Column field="workHours" header="Work Hours" body={(rowData, options) => work_Hours(rowData, options.rowIndex)} />
                    <Column field="" header="Timesheet" bodyStyle={{ minWidth: "10rem" }} body={(rowData, options) => time_Sheet(rowData, options.rowIndex)} />
                    <Column field="comments" header="Comments" body={(rowData, options) => comment(rowData, options.rowIndex)} />
                    <Column header="Action" body={(rowData, options) => actionBodyTemplate(rowData, options.rowIndex)} />
                </DataTable>
            </Dialog>
        </>
    );
}